// NATIVE

// INSTALLED

// CUSTOM
import { useDispatch } from 'react-redux';
import { AxiosAdapter } from '../commons/adapters';
import { closeSessionGlobal } from '../commons/utils';

const http = new AxiosAdapter();

export const getAllTipoNovedadService = async () => {
  try {
    return await http.get<any>(`/v1/type-news`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('getAllTipoNovedadService ', error);
  }
};

export const getDataCreateTipoNovedadService = async () => {
  try {
    return await http.get<any>(`/v1/type-news/create-type-new`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('getDataCreateTipoNovedadService ', error);
  }
};

export const createTipoNovedadService = async (
  tipoNovedad: object,
  setPercentajeCreateTurno: any
) => {
  try {
    return await http.post<any>(`/v1/type-news`, tipoNovedad, setPercentajeCreateTurno);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('createTipoNovedadService ', error);
  }
};

export const desactiveTipoNovedadService = async (parametroId: string) => {
  try {
    return await http.delete<any>(`/v1/type-news/${parametroId}`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('desactiveTipoNovedadService ', error);
  }
};

export const activeTipoNovedadService = async (tipoNovedadId: string) => {
  try {
    return await http.patch<any>(`/v1/type-news/${tipoNovedadId}`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('activeTipoNovedadService ', error);
  }
};

export const getTipoNovedadDetailService = async (tipoNovedadId: string) => {
  try {
    return await http.get<any>(`/v1/type-news/${tipoNovedadId}`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('getTipoNovedadDetailService ', error);
  }
};

export const getAllTipoNovedadesByPaginateService = async (page: number) => {
  try {
    return await http.get<any>(`/v1/type-news?page=${page}&take=10`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('getAllTipoNovedadesByPaginateService ', error);
  }
};

export const updateTipoNovedadDetailService = async (tipoNovedad: object) => {
  try {
    return await http.put<any>(`/v1/type-news`, tipoNovedad);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('updateTipoNovedadDetailService ', error);
  }
};
